// extracted by css-extract-rspack-plugin
export default {"root":"Mo0vy","chartContainer":"SgW5S","descriptionSection":"X8vII","visualizationPanel":"lS0zv","innerVisualization":"YQAtY"};